import styled from 'styled-components';

interface InputViewStyleProps {
  direction: 'row' | 'column';
}

export const Container = styled.div<InputViewStyleProps>`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  align-items: center;

  span {
    font-size: 1.4rem;
    color: #5d4e4f;

    &:first-of-type {
      color: #6c6c6c;
      font-weight: bold;
      margin-right: 1rem;
    }
  }

  @media (max-width: 600px) {
    align-items: unset;
    flex-direction: column;

    & + div {
      margin-top: 1rem;
    }

    span {
      &:first-of-type {
        margin-right: unset;
      }
    }
  }
`;
